import './index.css';
import { checkDisabledIcon } from '../../assets';

export const CheckBox = ({ label, value, onChange, disabled = false }) => {
  return (
    <div
      className={`check-box-container ${disabled ? "check-box-container-disabled" : ""} 
    ${value ? "check-box-container-selected" : ""} ${disabled && value ? "check-box-container-selected-disabled" : ""}`}
      onClick={() => {
        if (disabled) return;
        onChange(!value);
      }}
    >
      <div className="check-box-container-checkbox" >
        {value && <img src={checkDisabledIcon} alt="check" className="check-box-container-checkbox-icon" />}
      </div>
      {label && <span className="check-box-container-label">{label}</span>}
    </div>
  );
};